import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { useAuthToken } from "./useAuthToken"

export type SnowMetric = {
  Period: string
  Label: string
  Measurement: number
  Unit: string
  OriginalMeasurement: string
  OriginalUnit: string
  Location: string
}
export type SnowReportDay = {
  Date: string
  Source: string
  Timezone: string
  Outcome: "waiting" | "published" | "failed"
  CheckedAt: string
  ObservedAt: string | null
  FailureReason: string | null
  Report: {
    SourceURL: string
    LastUpdatedMessage: string
    Narrative: string
    Metrics: SnowMetric[] | null
  }
}
export function useResortSnowReports(uid: string, days: number) {
  const token = useAuthToken()
  return useQuery({
    queryKey: ["resort-snow-reports", uid, days],
    enabled: !!uid && !!token,
    queryFn: () => apiFetch<{ Sources: string[]; Days: SnowReportDay[] }>(
      `/admin/resorts/${encodeURIComponent(uid)}/snow-reports?days=${days}`, { token, method: "GET" },
    ),
    refetchInterval: 60_000,
  })
}
